export const AntdThemeToken = {
    colorLink: "#161616",
    colorLinkHover: "#161616",
    colorLinkActive: "#161616"
}